import { render, staticRenderFns } from "./regNPayResult.vue?vue&type=template&id=c54babf8"
import script from "./regNPayResult.vue?vue&type=script&lang=ts&scoped=true"
export * from "./regNPayResult.vue?vue&type=script&lang=ts&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports